/** True for `npm run build:demo` / REACT_APP_DEMO=true. */
export const isDemo = process.env.REACT_APP_DEMO === 'true';
